import React, { useState, useEffect, useCallback } from "react";
import { auth, db } from "../firebaseConfig";
import {
    collection, addDoc, getDocs, doc, deleteDoc, updateDoc, where,
    query,
} from "firebase/firestore";
import {
    Container,
    TextField,
    Button,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Snackbar,
    Alert,
    Box,
    MenuItem,
    InputLabel,
    Select,
    FormControl,
    Card,
    CardContent,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
//import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useMediaQuery, useTheme } from '@mui/material';
import VisibilityIcon from "@mui/icons-material/Visibility";
import TruckInspectionForm from "../components/TruckInspectionForm";
import CajaInspectionForm from "../components/CajaInspectionForm";


const SolicitudServicio = () => {
    const [solicitudservicios, setSolicitudServicios] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [formVisible, setFormVisible] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [currentsolicitudserviciosId, setCurrentsolicitudserviciosId] = useState(null);
    const [tipoUnidadList, setTipoUnidadList] = useState([]);
    const [tipoServiciosList, setTipoServiciosList] = useState([]);
    const initialFormData = {
        hacerChecklist: false,
        empresaId: '',
        unidadId: '',
        tipoServicioId: '',
        folio: '',
        folioDocumento: '',
        fecha: new Date().toLocaleString(),
    };
    const [formData, setFormData] = useState(initialFormData);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));
    const [isReadOnly, setIsReadOnly] = useState(false);



    useEffect(() => {
        const fetchsolicitudservicios = async () => {
            const solicitudserviciosSnapshot = await getDocs(collection(db, "solicitudservicios"));
            setSolicitudServicios(solicitudserviciosSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        };
        fetchsolicitudservicios();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (name === "metodoPago") {
            const updatedMetodoPago = checked
                ? [...formData.metodoPago, value]
                : formData.metodoPago.filter((v) => v !== value);
            setFormData({ ...formData, metodoPago: updatedMetodoPago });
        } else if (type === "checkbox") {
            setFormData({ ...formData, [name]: checked });
        } else if (type === "file") {
            const reader = new FileReader();
            reader.onload = () => {
                setFormData({ ...formData, archivo: reader.result });
            };
            reader.readAsDataURL(files[0]);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

 

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const user = auth.currentUser;
            if (!user) return;
            const userId = user.uid;

            const dataToSave = {
                ...formData,
                userId,
            };

            // Convertir archivo PDF a base64 si existe y es menor a 800 KB
            if (formData.archivo instanceof File) {
                const file = formData.archivo;
                if (file.size > 819200) {
                    alert("El archivo es demasiado grande. Usa un PDF de menos de 800 KB.");
                    return;
                }

                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });

                dataToSave.archivo = base64;
            } else if (!formData.archivo) {
                // Eliminar si no se proporciona archivo
                delete dataToSave.archivo;
            }

            if (editMode) {
                const SolicitudServiciosRef = doc(db, "solicitudservicios", currentsolicitudserviciosId);
                await updateDoc(SolicitudServiciosRef, dataToSave);
                setSolicitudServicios(solicitudservicios.map((sol) => sol.id === currentsolicitudserviciosId ? { id: currentsolicitudserviciosId, ...dataToSave } : sol));
                setAlertMessage("Solicitud de Servicios actualizada exitosamente.");
            } else {
                const newSolicitudServiciosRef = await addDoc(collection(db, "solicitudservicios"), dataToSave);
                setSolicitudServicios([...solicitudservicios, { id: newSolicitudServiciosRef.id, ...dataToSave }]);
                setAlertMessage("Solicitud de Servicios agregada exitosamente.");
            }

            // Reset formulario
            setFormVisible(false);
            setEditMode(false);
            setFormData({
                empresaId: '',
                unidadId: '',
                tipoServicioId: '',
                folio: '',
                fecha: '',
                folioDocumento: '',
               // fecha: new Date().toLocaleString(),
            });
            setAlertSeverity("success");
            setAlertOpen(true);
        } catch (error) {
            console.error(error);
            setAlertMessage("Error al guardar la Solicitud de Servicios.");
            setAlertSeverity("error");
            setAlertOpen(true);
        }
    };


    const handleDelete = async (solicitudserviciosId) => {
        try {
            await deleteDoc(doc(db, "solicitudservicios", solicitudserviciosId));
            setSolicitudServicios(solicitudservicios.filter((SolicitudServicios) => solicitudservicios.id !== solicitudserviciosId));
            setAlertMessage("SolicitudServicios eliminada exitosamente.");
            setAlertSeverity("success");
            setAlertOpen(true);
        } catch (error) {
            console.error("Error al eliminar SolicitudServicios:", error);
            setAlertMessage("Ocurrió un error al eliminar la solicitudservicios.");
            setAlertSeverity("error");
            setAlertOpen(true);
        }
        setOpenDeleteDialog(false);
    };

    const handleEdit = (SolicitudServicios) => {
        setFormVisible(true);
        setEditMode(true);
        setCurrentsolicitudserviciosId(SolicitudServicios.id);
        setFormData({ ...SolicitudServicios });
    };


    const handleViewSolicitudServicios = (SolicitudServicios) => {
        setCurrentsolicitudserviciosId(SolicitudServicios.folio);
        setFormData({ ...SolicitudServicios });
        setFormVisible(true);
        setIsReadOnly(true);
        setEditMode(true);
        // setOpenDialog(true); // Abrir el modal
    };


    const [formDataUnidad, setFormDataUnidad] = useState({
        id_tipoUnidad: '',
        numero: '',
        placa: '',
        marca: '',
        año: '',
        id_empresa: '',
    });

    const generarFolio = useCallback(async (tipoServicioId) => {
        const tipoServicioDoc = tipoServiciosList.find(t => t.id === tipoServicioId);
        if (!tipoServicioDoc) return null;
        const abreviatura = tipoServicioDoc.abreviatura || "XX";
        const serviciosQuery = query(
            collection(db, "solicitudservicios"),
            where("tipoServicioId", "==", tipoServicioId)
        );
        const snapshot = await getDocs(serviciosQuery);
        const numero = snapshot.size + 1;

        return `${abreviatura}-${String(numero).padStart(4, "0")}`;
    }, [tipoServiciosList]);

    useEffect(() => {
        console.log("Unidades cargadas:", unidades);
    }, [unidades]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const empresasSnap = await getDocs(collection(db, "empresas"));
                const tiposSnap = await getDocs(collection(db, "tipoServicios"));
                const tipoUnidadSnap = await getDocs(collection(db, "tipoUnidad"));
                const unidadesSnap = await getDocs(collection(db, "unidades"));
                setEmpresas(empresasSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setTipoServiciosList(tiposSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setTipoUnidadList(tipoUnidadSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setUnidades(unidadesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            } catch (error) {
                console.error("Error al obtener datos:", error);
            }
        };
        fetchData();
    }, []);


    const fetchUnidades = useCallback(async () => {
        if (!formData.empresaId) {
            setUnidades([]);
            return;
        }

        try {
            const unidadesQuery = query(
                collection(db, "unidades"),
                where("id_empresa", "==", formData.empresaId)
            );
            const unidadesSnap = await getDocs(unidadesQuery);
            setUnidades(unidadesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        } catch (error) {
            console.error("Error al obtener unidades:", error);
        }
    }, [formData.empresaId]);

    useEffect(() => {
        fetchUnidades();
    }, [fetchUnidades]);

    useEffect(() => {
        const generarFolioAsync = async () => {
            if (formData.tipoServicioId) {
                const nuevoFolio = await generarFolio(formData.tipoServicioId);
                setFormData(prev => ({ ...prev, folio: nuevoFolio }));
            }
        };

        generarFolioAsync();
    }, [formData.tipoServicioId, generarFolio]);

    const fetchSolicitudes = async () => {
        try {
            const solicitudesSnap = await getDocs(collection(db, "solicitudservicios"));
            setSolicitudServicios(solicitudesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        } catch (error) {
            console.error("Error al obtener solicitudes:", error);
        }
    };

    useEffect(() => {
        fetchSolicitudes();
    }, []);

    const handleUnidadChange = (e) => {
        const { name, value } = e.target;
        setFormDataUnidad((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmitUnidad = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, "unidades"), formDataUnidad);
            console.log("Unidad guardada:", formDataUnidad);
            setOpenModal(false);
            setFormDataUnidad({
                id_tipoUnidad: '',
                numero: '',
                placa: '',
                marca: '',
                año: '',
                id_empresa: '',
            });
            fetchUnidades();
        } catch (error) {
            console.error("Error al guardar unidad:", error);
        }
    };

    function SolicitudServicio({ tipoServicio }) {
        const handleGuardarSolicitud = async (datosInspeccion) => {
          try {
            // 1. Guardar inspección y obtener ID
            const docRef = await addDoc(collection(db, "inspecciones"), datosInspeccion);
            const idInspeccion = docRef.id;
      
            // 2. Guardar solicitud con idInspeccion
            const solicitud = {
              fecha: new Date(),
              tipoServicio,
              idInspeccion, // aquí vinculas la inspección
              // ...otros datos
            };
      
            await addDoc(collection(db, "solicitudServicio"), solicitud);
            alert("Solicitud y inspección guardadas correctamente");
      
          } catch (error) {
            console.error("Error al guardar:", error);
          }
        };
      
        return (
          <>
            {tipoServicio === "camion" ? (
              <TruckInspectionForm onGuardar={handleGuardarSolicitud} />
            ) : (
              <CajaInspectionForm onGuardar={handleGuardarSolicitud} />
            )}
          </>
        );
      }



    return (
        <Container maxWidth="lg" sx={{ paddingBottom: 2 }}>

            {!formVisible ? (
                <>
                    <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>Solicitud de Servicios</Typography>
                    <Button variant="contained" startIcon={<AddCircleIcon />} onClick={() => {
                        setFormData(initialFormData);
                        setEditMode(false);
                        setCurrentsolicitudserviciosId(null);
                        setFormVisible(true);
                    }} sx={{ mb: 2 }}>Nueva Solicitud de Servicios</Button>

                    {isMobile ? (
                        <Box>
                            {solicitudservicios.map((SolicitudServicios) => (
                                <Card
                                    key={solicitudservicios.id}
                                    sx={{ marginBottom: 2, padding: 2 }}
                                >
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography variant="h6" fontWeight="bold">Folio: {SolicitudServicios.folio}</Typography>
                                        <Typography variant="body2"><strong>Empresa:</strong> {empresas.find((empresa) => empresa.id === SolicitudServicios.empresaId)?.nombre}</Typography>
                                        {/* <Typography variant="body2"><strong>Unidad:</strong> {SolicitudServicios.email}</Typography> */}
                                        <Typography variant="body2"><strong>Tipo de Servicio:</strong> {tipoServiciosList.find((tipo) => tipo.id === SolicitudServicios.tipoServicioId)?.nombre}</Typography>
                                        <Typography variant="body2"><strong>Fecha de Solicitud:</strong> {new Date(SolicitudServicios.fecha).toLocaleDateString()}</Typography>

                                    </CardContent>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, pb: 1 }}>
                                        <IconButton color="primary" onClick={() => handleViewSolicitudServicios(SolicitudServicios)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                        <IconButton color="primary" onClick={() => handleEdit(SolicitudServicios)}>
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton color="secondary" onClick={() => handleDelete(SolicitudServicios.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                </Card>
                            ))}
                        </Box>
                    ) : (
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Folio</TableCell>
                                        <TableCell>Empresa</TableCell>
                                        {/* <TableCell>Unidad</TableCell>    */}
                                        <TableCell>Tipo de Servicio</TableCell>
                                        <TableCell>Fecha de Solicitud</TableCell>
                                        <TableCell>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {solicitudservicios.map((SolicitudServicios) => (
                                        <TableRow key={SolicitudServicios.folio}>
                                            <TableCell>{SolicitudServicios.folio}</TableCell>
                                            <TableCell>{empresas.find((empresa) => empresa.id === SolicitudServicios.empresaId)?.nombre}</TableCell>
                                            {/* <TableCell>{unidades.find((unidad) => unidad.id === SolicitudServicios.unidadId)?.numero}</TableCell> */}
                                            <TableCell>{tipoServiciosList.find((tipo) => tipo.id === SolicitudServicios.tipoServicioId)?.nombre}</TableCell>
                                            <TableCell>{new Date(SolicitudServicios.fecha).toLocaleDateString()}</TableCell>
                                            <TableCell>
                                                <IconButton color="primary" onClick={() => handleViewSolicitudServicios(SolicitudServicios)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton color="primary" onClick={() => handleEdit(SolicitudServicios)}>
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton color="secondary" onClick={() => handleDelete(SolicitudServicios.folio)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </>
            ) : (
                <Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>{editMode ? "Editar Solicitud de Servicios" : "Nueva Solicitud de Servicios"}</Typography>
                        {isReadOnly && (
                            <IconButton color="secondary" onClick={() => {
                                setIsReadOnly(false);
                                handleEdit(formData);
                            }}>
                                <EditIcon />
                            </IconButton>
                        )}
                        <IconButton onClick={() => setFormVisible(false)}><CloseIcon /></IconButton>
                    </Box>
                    <form onSubmit={handleSubmit}>
                        {/* Empresa */}
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Empresa</InputLabel>
                            <Select name="empresaId" value={formData.empresaId} onChange={handleChange} required>
                                {empresas.map(emp => (
                                    <MenuItem key={emp.id} value={emp.id}>
                                        {emp.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Unidad */}
                        {unidades.length > 0 ? (
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Unidad</InputLabel>
                                <Select name="unidadId" value={formData.unidadId} onChange={handleChange} required>
                                    {unidades.map(uni => (
                                        <MenuItem key={uni.id} value={uni.id}>
                                            {uni.numero}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        ) : (
                            formData.empresaId && (
                                <div>
                                    <Typography variant="body1" color="textSecondary" gutterBottom>
                                        No hay unidades registradas para esta empresa.
                                    </Typography>
                                    <Button variant="outlined" onClick={() => {
                                        setFormDataUnidad(prev => ({ ...prev, id_empresa: formData.empresaId }));
                                        setOpenModal(true);
                                    }}>
                                        Registrar Unidad
                                    </Button>
                                </div>
                            )
                        )}

                        {/* Tipo de servicio */}
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Tipo de Servicio</InputLabel>
                            <Select
                                name="tipoServicioId"
                                value={formData.tipoServicioId}
                                onChange={handleChange}
                                required
                            >
                                {tipoServiciosList.map((tipo) => (
                                    <MenuItem key={tipo.id} value={tipo.id}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            fullWidth
                            label="Folio generado"
                            margin="normal"
                            value={formData.folio}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                            }}
                        />

                          {/* Mostrar formulario condicionalmente */}
                    {(() => {
                        const servicioSeleccionado = tipoServiciosList.find(
                            (tipo) => tipo.id === formData.tipoServicioId
                        );

                        if (!servicioSeleccionado) return null;

                        if (servicioSeleccionado.nombre.toLowerCase().includes("tractocamion")) {
                            return (
                                <Card sx={{ mt: 3 }}>
                                    <CardContent>
                                        <TruckInspectionForm />
                                    </CardContent>
                                </Card>
                            );
                        }

                        if (servicioSeleccionado.nombre.toLowerCase().includes("remolque")) {
                            return (
                                <Card sx={{ mt: 3 }}>
                                    <CardContent>
                                        <CajaInspectionForm />
                                    </CardContent>
                                </Card>
                            );
                        }

                        return null;
                    })()}


                        <Button type="submit" variant="contained" disabled={isReadOnly} fullWidth>{editMode ? "Actualizar Solicitud de Servicios" : "Guardar Solicitud de Servicios"}</Button>
                    </form>
                </Box>
            )}
            <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)}>
                <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>{alertMessage}</Alert>
            </Snackbar>
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>Confirmación</DialogTitle>
                <DialogContent>
                    <Typography>¿Estás seguro de eliminar esta Solicitud Servicios?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">Cancelar</Button>
                    <Button onClick={() => handleDelete(currentsolicitudserviciosId)} color="secondary">Eliminar</Button>
                </DialogActions>
            </Dialog>

            {/* MODAL DE REGISTRO DE UNIDAD */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)}>
                <DialogTitle>
                    Registrar Nueva Unidad
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenModal(false)}
                        aria-label="close" sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmitUnidad}>
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Tipo de Unidad</InputLabel>
                            <Select
                                name="id_tipoUnidad"
                                value={formDataUnidad.id_tipoUnidad}
                                onChange={handleUnidadChange}
                                required
                            >
                                {tipoUnidadList.map(tipo => (
                                    <MenuItem key={tipo.id} value={tipo.id}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            label="Número"
                            name="numero"
                            value={formDataUnidad.numero}
                            onChange={handleUnidadChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                        <TextField
                            label="Placa"
                            name="placa"
                            value={formDataUnidad.placa}
                            onChange={handleUnidadChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                        <TextField
                            label="Marca"
                            name="marca"
                            value={formDataUnidad.marca}
                            onChange={handleUnidadChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                        <TextField
                            label="Año"
                            name="año"
                            type="number"
                            value={formDataUnidad.año}
                            onChange={handleUnidadChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                        <Box mt={2}>
                            <Button variant="contained" color="primary" type="submit" fullWidth>
                                Registrar Unidad
                            </Button>
                        </Box>
                    </form>
                </DialogContent>
            </Dialog>
        </Container>
    );
};

export default SolicitudServicio;
